// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"841ad17e","295":"4f03ef57","332":"ee12fdf4","368":"a6167584","407":"20a6ec7d","447":"60127c49","455":"ea530ed4","715":"54a993d7","719":"237e3bb9","937":"277e8e6b","977":"d4fbbbfe"}[chunkId] + ".chunk.js";
};